import React, { useState } from 'react';
import images from '../images';
import {useNavigate} from "react-router-dom";
import MobilePasswordResetForm from "../components/Forms/MobilePasswordResetForm";

const MobileForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Пожалуйста, введите email');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // Заглушка для функции восстановления пароля
      console.log('Отправка письма на', email);
      // Имитация задержки
      await new Promise(resolve => setTimeout(resolve, 1000));
      navigate('/login');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{backgroundImage: `url(${images.loginBackground})` }} className="mobile-login-container">

        <div className="mobile-login-content">
          <MobilePasswordResetForm
            email={email}
            setEmail={setEmail}
            loading={loading}
            error={error}
            handleSubmit={handleSubmit}
          />
        </div>

    </div>
  );
};

export default MobileForgotPassword;